import users from '@/api/modules/users';

export default {
	async getList({ commit }, param = '') {
		try {
			commit('setUserList', []);
			let result = await users.getList(param);
			result = result.map(user => {
				if (user.surname && user.name) {
					user.full_name = `${user.surname} ${user.name}`;
				}

				return user;
			});
			commit('setUserList', result);
		} catch (err) {
			//
		}
	},

	async createUser({ commit }, body) {
		try {
			const result = await users.createUser(body);
			commit('createUser', result);
		} catch(err) {
			//
		}
	},

	async editUser({ commit }, body) {
		try {
			const result = await users.editUser(body);
			commit('editUser', result);
		} catch(err) {
			//
		}
	},

	async deleteUser({ commit }, id) {
		try {
			await users.deleteUser(id);
			commit('deleteUser', id);
		} catch(err) {
			//
		}
	},

	async getUserRoles(_, id) {
		try {
			const result = await users.getUserRoles(id);
			return result;
		} catch (err) {
			//
		}
	},

	async getRoles({ commit }) {
		try {
			let result = await users.getRoles();
			commit('setRoleList', result);
		} catch(err) {
			// 
		}
	},

	async setRoles(_, { id , body }) {
		try {
			await users.setRoles({ id, body });
		} catch(err) {
			//
		}
	}
  
};
